export default function LabelPoint({props}) {
    return <span>{props?.pointLabel || "포"}</span>
}